<template>
  <ul class="kefuche">
    <li>
      <a href="javascript:void(0)" @click="showMedia">
        <img src="/static/img/kefu@1x.png" class="img" alt="客服">
        <span>客服</span>
      </a>
    </li>

    <li class="line"></li>
    <li class="code-box" style="text-align:center;">
      <a href="http://wpa.qq.com/msgrd?v=3&amp;uin=951756575&amp;site=qq&amp;menu=yes" target="_blank" title="企业QQ交谈" rel="nofollow">
        <img src="/static/img/qq.png" style="width:38px;height:38px;" alt="企业QQ">
        <span>企业QQ</span>
      </a>
    </li>
    
    <li class="line"></li>
    <li class="cart-box">
      <span @click="goCartPage">
        <img src="/static/img/zuwuche-bai@1x.png" class="img" style="margin-left: 13px;" alt="租物车">
        <span>租物车</span>
        <span v-if="cartNum" class="num">{{cartNum}}</span>
      </span>
    </li>
    <!-- <li class="line"></li>
    <li v-if="isShow" @click="goTop">
      <img src="/static/img/toTop.png" style="margin-left: 17px;" alt="">
      <span>回到顶部</span>
    </li> -->

    <li class="line"></li>
    <li class="code-box">
      <img src="/static/img/static_code.png" class="img" alt="器材租赁手机下单">
      <span>手机下单</span>
      <div class="big-code">
        <div class="code-top">
          <div class="code-img-box">
            <img src="/static/img/code.png" alt="APP下载二维码">
          </div>
          <p class="code-line-1 c9">APP下载</p>
          <p class="code-line-2 c9">随时随地 想租就租</p>
        </div>
        <div class="code-bot">手机下单认证减免押金</div>
      </div>
    </li>
  </ul>
</template>
<script>
import VueCookies from "vue-cookies";

import { mapState } from "vuex";
export default {
  name: "kefuche",
  data() {
    return {
      isShow: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.scrollToTop);
    });
  },
  computed: {
    ...mapState({
      cartNum: state => state.userOrder.cartNum
    })
  },
  methods: {
    showMedia() {
      if(window._MEIQIA==undefined){
        (function(m, ei, q, i, a, j, s) {
          m[i] =
            m[i] ||
            function() {
              (m[i].a = m[i].a || []).push(arguments);
            };
          (j = ei.createElement(q)), (s = ei.getElementsByTagName(q)[0]);
          j.async = true;
          j.charset = "UTF-8";
          j.src = "https://static.meiqia.com/dist/meiqia.js?_=t";
          s.parentNode.insertBefore(j, s);
        })(window, document, "script", "_MEIQIA");
        _MEIQIA("entId", 138356);

        if (VueCookies.get("user_mobile")) {
          // 传递顾客信息
          _MEIQIA("metadata", {
            name: VueCookies.get("uid"), // 美洽默认字段
            tel: VueCookies.get("user_mobile")
          });
        }

        // 初始化成功后调用美洽 showPanel
        // _MEIQIA("allSet", function() {
        //   _MEIQIA("showPanel");
        // });

        // 在这里开启无按钮模式（常规情况下，需要紧跟在美洽嵌入代码之后）
        _MEIQIA("withoutBtn");
        _MEIQIA("init");
      }
      _MEIQIA("showPanel");
    },
    scrollToTop() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isShow = scrollTop > 0;
    },
    goTop() {
      window.scroll(0, 0);
    },
    goCartPage() {
      var browser_token = this.$cookies.get("browser_token");
      if (browser_token) {
        // this.$router.push("/ShoppingCart");
        this.$store.dispatch("routerStatus/changeIdxAction", 5);
        this.$router.push("/newMyCart");
      } else {
        this.$router.push("/UserLogin");
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  }
};
</script>
<style scoped>
.kefuche {
  z-index: 99999;
  position: fixed;
  right: 0;
  bottom: 10%;
  padding: 12px 0px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  /* border-radius: 4px; */
  /* background-image: -webkit-linear-gradient(top, #ffd778, #fd314a); */
  background: -webkit-linear-gradient(to top, #ffd778, #fd314a);
  /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(to top, #ffd778, #fd314a);
  /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(to top, #ffd778, #fd314a);
  /* Firefox 3.6 - 15 */
  background: linear-gradient(to top, #ffd778, #fd314a);
  /* 标准的语法 */
}
.kefuche li {
  cursor: pointer;
}
.kefuche .line {
  width: 51px;
  height: 1px;
  margin: 10px;
  background: #fff;
}
.kefuche li .img {
  width: 38px;
  height: 38px;
  margin: 0 auto;
  display: block;
}
.kefuche li span {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #fff;
}
.code-box {
  position: relative;
}
.big-code {
  position: absolute;
  right: 71px;
  bottom: -12px;
  width: 200px;
  height: 260px;
  border: 2px solid #fd314a;
  background: #fd314a;
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: 100% 100%;
  -moz-transform-origin: 100% 100%;
  -ms-transform-origin: 100% 100%;
  -o-transform-origin: 100% 100%;
  transform-origin: 100% 100%;
  -webkit-transition: 0.2s ease-in-out;
  -moz-transition: 0.2s ease-in-out;
  -ms-transition: 0.2s ease-in-out;
  -o-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}
.code-top {
  background: #fff;
}
.code-img-box {
  padding: 15px 15px 0;
}
.kefuche .big-code img {
  width: 100%;
}
.code-line-1 {
  text-align: center;
  line-height: 20px;
  font-size: 13px;
}
.code-line-2 {
  text-align: center;
  line-height: 20px;
  font-size: 14px;
}
.code-bot {
  text-align: center;
  color: #fff;
  line-height: 37px;
  font-size: 15px;
}
.code-box:hover .big-code {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
}
.cart-box {
  position: relative;
}
.num {
  position: absolute;
  right: 12px;
  top: -6px;
  background: #fff;
  color: red !important;
  border-radius: 50%;
  padding: 0 2px;
  font-size: 12px !important;
  min-width: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/kefuChe.vue